<template>
  <div>
    <v-card>
      <v-card-title>
        <v-toolbar
          flat
          color="white"
        >
          <v-toolbar-title>Поставки на складе</v-toolbar-title>

          <v-spacer />

          <v-text-field
            v-model="search"
            append-icon="search"
            label="Поиск"
            single-line
            hide-details
            :disabled="true"
          />

          <DataColumnsSettings
            :columns="headers"
            resource="warehouseDetails"
            :settings-button-style="{
              flat: true,
              colorButton: '',
              colorIcon: 'grey'
            }"
            :disabled="true"
          />
        </v-toolbar>
      </v-card-title>

      <v-data-table
        :items="items"
        :headers="visibleColumns"
        :headers-length="35"
        :loading="loading"
        :pagination.sync="pagination"
        :total-items="totalItems"
        :rows-per-page-items="[10]"
        hide-actions
        class="elevation-1 mb-1 table-striped"
        item-key="Id"
      >
        <template
          slot="headers"
          slot-scope="props"
        >
          <template
            v-for="(headers, i) in [processTableHeaders(props.headers)]"
          >
            <tr :key="i">
              <th
                v-for="(header, p) in headers.parents"
                :key="p + 'parent'"
                :rowspan="header.rowspan"
                :colspan="header.colspan"
                class="bordered"
                :style="{
                  minWidth: header.width ? `${header.width}px` : 'auto',
                  height: header.title.length * (header.rotate ? 9 : 1) + 'px',
                  'white-space': 'normal',
                  'line-height': '1.5'
                }"
              >
                <div :class="{ rotate: header.rotate }">
                  {{ header.title }}
                </div>
              </th>
            </tr>
            <tr
              v-if="headers.children"
              :key="i + 'second'"
            >
              <th
                v-for="(header, c) in headers.children"
                :key="c + 'child'"
                class="bordered"
                :style="{
                  minWidth: header.width ? `${header.width}px` : 'auto',
                  height: header.title.length * (header.rotate ? 9 : 1) + 'px',
                  'white-space': 'normal',
                  'line-height': '1.5'
                }"
              >
                <div :class="{ rotate: header.rotate }">
                  {{ header.title }}
                </div>
              </th>
            </tr>
          </template>
        </template>
        <template
          slot="items"
          slot-scope="props"
        >
          <tr :class="{ 'green accent-1': selectedRow == props.index }">
            <template v-for="(column, i) in visibleColumns">
              <td
                v-if="column.name && !column.children"
                :key="i"
              >
                <span v-if="column.editor && column.editor !== 'DATE'">
                  <component
                    :is="cellEditors[column.editor]"
                    :value="props.item[column.name]"
                    :item="props.item"
                    :index="props.index"
                    :column="column"
                    :disabled="true"
                  />
                </span>
                <span v-else-if="column.editor === 'DATE'">
                  <app-date-picker
                    v-model="props.item[column.name]"
                    class="mx-0 date-picker"
                    :without-initial-data="true"
                    :hide-data-type-icon="true"
                    :disabled="true"
                    @input="save(props.item)"
                    @opened="updateSelectedRow(props.index)"
                  />
                </span>
                <span v-else-if="column.type === 'object'">{{
                  props.item[column.name] ? props.item[column.name].Title : ""
                }}</span>
                <span v-else-if="column.type === 'date'">{{
                  props.item[column.name] | date
                }}</span>
                <span v-else-if="column.type === 'fixedNumber'">{{
                  props.item[column.name] | fixedNumber(3)
                }}</span>
                <span v-else-if="column.type === 'number'">
                  <LinkCell
                    :id="props.item.shippingId"
                    :text="props.item[column.name]"
                    resource="shippings"
                  />
                </span>
                <span v-else>{{ props.item[column.name] }}</span>
              </td>
              <td
                v-for="(child, j) in column.children"
                v-else-if="column.children"
                :key="`${i}-${j}`"
              >
                <span v-if="child.editor && child.editor !== 'DATE'">
                  <component
                    :is="cellEditors[child.editor]"
                    :value="props.item[child.name]"
                    :item="props.item"
                    :index="props.index"
                    :column="child"
                    :disabled="true"
                  />
                </span>
                <span v-else-if="child.editor === 'DATE'">
                  <app-date-picker
                    v-model="props.item[child.name]"
                    class="mx-0 date-picker"
                    :without-initial-data="true"
                    :hide-data-type-icon="true"
                    :disabled="true"
                    @input="save(props.item)"
                    @opened="updateSelectedRow(props.index)"
                  />
                </span>
                <span v-else-if="child.type === 'object'">{{
                  props.item[child.name] ? props.item[child.name].Title : ""
                }}</span>
                <span v-else-if="child.type === 'date'">{{
                  props.item[child.name] | date
                }}</span>
                <span v-else-if="child.type === 'fixedNumber'">{{
                  props.item[child.name] | fixedNumber(3)
                }}</span>
                <span v-else>{{ props.item[child.name] }}</span>
              </td>
            </template>
          </tr>
        </template>
      </v-data-table>
    </v-card>
    <div class="text-xs-center pt-2">
      <v-pagination
        v-model="pagination.page"
        :length="pages"
      />
    </div>
  </div>
</template>

<script>
import CombinedLabel from "./components/cell-editors/Old_CombinedLabel.vue";
import TextEditor from "./components/cell-editors/TextEditor.vue";
import EnumEditor from "./components/cell-editors/EnumEditor.vue";
import RefEditor from "./components/cell-editors/RefEditor.vue";
import DecimalEditor from "./components/cell-editors/DecimalEditor.vue";
import DataColumnsSettings from "../../components/data-list/DataColumnsSettings.vue";
import { cellEditors } from "./components/cell-editors/cell-editors.js";
import LinkCell from "../../components/LinkCell.vue";

export default {
  components: {
    CombinedLabel,
    TextEditor,
    EnumEditor,
    RefEditor,
    DecimalEditor,
    DataColumnsSettings,
    LinkCell,
  },
  data() {
    return {
      pagination: {},
      search: "",
    };
  },
  computed: {
    pages() {
      if (this.pagination.rowsPerPage == null || this.totalItems == null) {
        return 0;
      }
      return Math.ceil(this.totalItems / this.pagination.rowsPerPage);
    },
    headers() {
      return this.$store.getters["oldVersionWarehouseDetails/headers"];
    },
    visibleColumns() {
      const visibleColumns = this.headers.filter(
        c => !Object.prototype.hasOwnProperty.call(c, "visible") || c.visible,
      );
      visibleColumns.sort((a, b) => {
        if (a.children) {
          a.children.sort((current, next) => {
            let currentOrder = 0;
            if (Object.prototype.hasOwnProperty.call(current, "order")) {
              currentOrder = current.order;
            } else {
              currentOrder = a.children.indexOf(current);
            }
            let nextOrder = 0;
            if (Object.prototype.hasOwnProperty.call(next, "order")) {
              nextOrder = next.order;
            } else {
              nextOrder = a.children.indexOf(next);
            }
            if (currentOrder < nextOrder) {
              return -1;
            }
            if (currentOrder > nextOrder) {
              return 1;
            }
            return 0;
          });
        }
        let aOrder = 0;
        if (Object.prototype.hasOwnProperty.call(a, "order")) {
          aOrder = a.order;
        } else {
          aOrder = this.headers.indexOf(a);
        }
        let bOrder = 0;
        if (Object.prototype.hasOwnProperty.call(b, "order")) {
          bOrder = b.order;
        } else {
          bOrder = this.headers.indexOf(b);
        }
        if (aOrder < bOrder) {
          return -1;
        }
        if (aOrder > bOrder) {
          return 1;
        }
        return 0;
      });
      return visibleColumns;
    },
    items: {
      get() {
        return this.$store.getters["oldVersionWarehouseDetails/items"];
      },
      set(value) {
        return this.$store.commit("oldVersionWarehouseDetails/setItems", value);
      },
    },
    totalItems: {
      get() {
        return this.$store.getters["oldVersionWarehouseDetails/totalItems"];
      },
      set(value) {
        return this.$store.commit(
          "oldVersionWarehouseDetails/setTotalItems",
          value,
        );
      },
    },
    loading: {
      get() {
        return this.$store.getters["oldVersionWarehouseDetails/loading"];
      },
      set(value) {
        return this.$store.commit(
          "oldVersionWarehouseDetails/setLoading",
          value,
        );
      },
    },
    cellEditors() {
      return cellEditors;
    },
    selectedRow: {
      get() {
        return this.$store.getters["oldVersionWarehouseDetails/selectedRow"];
      },
      set(value) {
        return this.$store.commit(
          "oldVersionWarehouseDetails/setSelectedRow",
          value,
        );
      },
    },
  },
  watch: {
    pagination: {
      async handler() {
        await this.$store.dispatch("oldVersionWarehouseDetails/getData", {
          page: this.pagination.page,
          rowsPerPage: this.pagination.rowsPerPage,
        });
      },
      deep: true,
    },
  },
  methods: {
    async save(item) {
      await this.$store.dispatch("oldVersionWarehouseDetails/save", item);
      await this.$store.dispatch("oldVersionWarehouseDetails/getData", {
        page: this.pagination.page,
        rowsPerPage: this.pagination.rowsPerPage,
      });
    },
    processTableHeaders(headers) {
      const nested = !!headers.some(h => h.children);

      if (nested) {
        const children = [];

        const h = headers.map(h => {
          if (h.children && h.children.length > 0) {
            children.push(...h.children);

            return {
              rowspan: 1,
              colspan: h.children.length,
              title: h.title,
              align: h.align,
              rotate: h.rotate,
              type: h.type ? h.type : "",
              editor: h.editor ? h.editor : "",
              sortable: h.sortable,
              width: h.width ? h.width : "",
              visible: h.visible ? h.visible : true,
              order: h.order ? h.order : 0,
            };
          }
          return {
            rowspan: 2,
            colspan: 1,
            title: h.title,
            align: h.align,
            rotate: h.rotate,
            type: h.type ? h.type : "",
            editor: h.editor ? h.editor : "",
            sortable: h.sortable,
            width: h.width ? h.width : "",
            visible: h.visible ? h.visible : true,
            order: h.order ? h.order : 0,
          };
        });

        return {
          children,
          parents: h,
        };
      }
      return {
        parents: headers,
      };
    },
    updateSelectedRow(item) {
      return this.$store.commit(
        "oldVersionWarehouseDetails/setSelectedRow",
        item,
      );
    },
    //     loadFile(file) {
    //       const attachment = {
    //         originName: file.originName,
    //         type: 1,
    //         data: file.data
    //       };
    //       this.$http
    //         .post(`shippings/${this.selectedShippingId}/attachments`, attachment)
    //         .then(res => {
    //           this.getData();
    //         });
    //     }
  },
};
</script>
<style scoped>
.bordered {
  border: 1px solid #13121222;
}
.rotate {
  transform: rotate(-90deg);
}
td .date-picker .v-menu {
  min-width: 100px;
  margin: 0 !important;
}
td .date-picker .v-input {
  margin: 0;
}
td .date-picker input {
  font-size: 13px;
}
td .date-picker .v-input__slot:before {
  border: none;
}
td .date-picker .v-text-field .v-input__slot:after {
  border: none !important;
}
.pointer,
.pointer.v-chip .v-chip__content {
  cursor: pointer;
}
.icon-reveal {
  display: block;
}
.v-small-dialog__actions .v-btn {
  height: 28px;
  margin: 4px 0;
  padding: 0;
}
</style>
